export default __webpack_public_path__ + "static/media/energy.e92bd912.png";